import apiClient from "../../../helpers/apiClient";

/*
 * Re-prices a reservation's invoice for its current period with today's rates, addons and
 * insurance. The backend rebuilds it and keeps extra charges, refunds, tolls, the deposit and the
 * payment history as stored.
 */

export const canRefreshReservationInvoice = (reservation) =>
    Boolean(
        reservation?.flag &&
            reservation?.invoice &&
            !reservation.isInsuranceOnly &&
            !reservation.isCancelled &&
            !reservation.isRejected,
    );

/** @returns {Promise<object>} the updated reservation */
export const refreshReservationInvoice = async (reservation) => {
    const { data } = await apiClient.patch(`/api/reservation/refresh-invoice/${reservation.id}`);

    if (!data?.success) {
        throw new Error(data?.message || "Could not refresh invoice.");
    }
    return data?.data;
};
